import { getId } from './channelInstanceGetters';
export const getChannelInstanceById = ({
  channelInstances,
  id
}) => {
  if (!channelInstances || !id) return null;
  return channelInstances.find(instance => getId(instance) === id);
};